<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить домофон</h2>
        <el-form
          class="page__form"
          id="formCreateIntercom"
          :model="intercom"
          ref="form"
          :rules="rules"
          label-position="right"
          label-width="240px"
        >
          <el-form-item label="Название" prop="short_name">
            <el-input id="short_name" size="small" v-model="intercom.short_name" />
          </el-form-item>
          <el-form-item label="Адрес" prop="address">
            <el-input id="address" size="small" v-model="intercom.address" />
          </el-form-item>
          <el-form-item label="UUID" prop="uuid">
            <el-input id="uuid" size="small" v-model="intercom.uuid" />
          </el-form-item>
          <el-form-item label="Начало диапазона квартир" prop="apartment_from">
            <el-input id="apartment_from" size="small" v-model="intercom.apartment_from" />
          </el-form-item>
          <el-form-item label="Конец диапазона квартир" prop="apartment_to">
            <el-input id="apartment_to" size="small" v-model="intercom.apartment_to" />
          </el-form-item>
          <el-form-item label="Смещение диапазона квартир" prop="apartment_offset">
            <el-input id="apartment_offset" size="small" v-model="intercom.apartment_offset" />
          </el-form-item>
          <el-form-item label="SIP-сервер" prop="id_sip_server">
            <select-sip-server
              :sip-server-id="intercom.id_sip_server"
              @change="(id_sip_server) => (intercom.id_sip_server = id_sip_server)"
              @clear="() => (intercom.id_sip_server = null)"
            />
          </el-form-item>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import { required, length, validatorNumber } from "@/core/helpers/validators";
import SelectSipServer from '@/components/SipServers/components/feature/SelectSipServer.vue';

export default {
  name: "FormCreateIntercom",
  components: {
    SelectSipServer
  },
  data() {
    return {
      intercom: {
        short_name: "",
        address: "",
        uuid: "",
        apartment_from: "",
        apartment_to: "",
        apartment_offset: "",
        id_sip_server: "",
      },
      rules: {
        short_name: [required(), length(2, 100)],
        address: [required(), length(2, 200)],
        uuid: [required(), length(4, 100)],
        apartment_from: [required(), validatorNumber, length(1, 10)],
        apartment_to: [required(), validatorNumber, length(1, 10)],
        apartment_offset: [required(), validatorNumber, length(1, 10)],
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.create(this.intercom)
            .then((id) => {
              this.$message({
                message: "Домофон успешно создан",
                type: "success",
              });
              this.$router.push({ name: "intercom:edit", params: { id } });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error || "Ошибка при добавлении домофона");
            });
        }
        return valid;
      });
    },
    ...mapActions("intercom", {
      create: "ADD_INTERCOM",
    }),
  },
};
</script>
